import { ApiClientError } from 'api/client';
import { useSubscription } from 'app/modules/settings/modules/billing/hooks/useBillingQueries';

/**
 * Whether the NewBilling `/billing/*` routes answer for this account at all.
 *
 * The api 404s them when the account is not on NewBilling (flag OFF, or a
 * legacy-engine account), so a positively resolved 404 on
 * `GET /billing/subscription` is the one "definitely not" signal. Anything else
 * — loading, 200, 403 for a role without `access_billing`, 5xx — leaves the
 * routes presumed available.
 *
 * This is deliberately NOT the "is this account governed by NewBilling"
 * decision: that also needs the entitlements `billingEngine`, and the
 * entitlements query itself is gated on this hook, so it lives in its own file
 * to keep `useEntitlements` and `useIsNewBillingEnabled` from depending on each
 * other.
 */
export function useNewBillingRoutesAvailable(): boolean {
  const subscriptionQuery = useSubscription();
  const status = (subscriptionQuery.error as ApiClientError | undefined)
    ?.axiosError?.response?.status;
  return status !== 404;
}
